import _ArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import React from 'react';
import { Image, ImageEntity } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Wrapper = styled.div.withConfig({
  componentId: "sc-rsddmg-0"
})(["display:flex;align-items:center;gap:8px;"]);
export default function TeamEmblems(_ref) {
  let {
    fromTeam,
    toTeam,
    secondPlayingRight
  } = _ref;
  const arrowIcon = /*#__PURE__*/React.createElement(_ArrowRightAlt, {
    color: "action"
  });
  const fromTeamEmblem = fromTeam ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: fromTeam.getEmblem(),
    width: 24,
    height: 24,
    fit: true
  }) : null;
  const toTeamEmblem = toTeam ? /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: toTeam.getEmblem(),
    width: 24,
    height: 24,
    fit: true
  }) : null;
  if (secondPlayingRight) {
    return /*#__PURE__*/React.createElement(Wrapper, null, toTeamEmblem);
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TeamEmblems",
    "data-sentry-source-file": "TeamEmblems.tsx"
  }, fromTeamEmblem, arrowIcon, toTeamEmblem);
}